import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'nova-card',
    template: `
        <mat-card
            class="nova__sub-header__box"
            [ngClass]="classes">
            <ng-content></ng-content>
        </mat-card>
    `,
    styleUrls: ['./nova-card.component.scss'],
    standalone: true,
    imports: [MatCardModule, NgClass]
})
export class CardComponent {
    @Input()
    classes: string | string[] | Set<string> | { [klass: string]: unknown };
}
